import { RequisitionForm } from "../components/requisition/RequisitionForm";

export const RequisitionPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          Request Stock Items
        </h1>
        <p className="text-gray-500 mt-1">
          Submit a requisition for items from inventory
        </p>
      </div>

      <RequisitionForm />
    </div>
  );
};